import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { find } from "lodash";
import { TreeNode } from "primeng/api";
import { AllocationItem } from "../domain/allocationitem";
import { AccountService } from "../service/account.service";
import { AllocationDefinitionService } from "../service/allocationdefinition.service";
import { LookupService } from "../service/lookup.service";

@Component({
    selector: "modal-dimension-value-picker",
    templateUrl: "./modal-dimension-value-picker.component.html",
})
export class ModalDimensionValuePicker implements OnInit {
    constructor(private lookupService: LookupService) {
        this.tableColumns = [{ field: "name", header: "Name", width: "100%" }];
    }

    @Input() dimensionId: number;
    @Input() buttonText: string = null;
    @Input() textonly: string = null;

    @Input() dimensionValueId: number;

    @Output() dimensionValueIdChange = new EventEmitter();

    @Output() onClose = new EventEmitter<boolean>();

    displayTable: boolean = false;
    linesForTable: TreeNode[] = [];
    tableColumns: any[];
    loading: boolean = false;
    error: string = null;
    selected: TreeNode;
    selectedDimensionValue: TreeNode;

    ngOnInit() {
        if (this.dimensionId) {
            this.loading = true;

            this.lookupService.getDimensionValues(this.dimensionId)
                .then((dimensionValues) => {
                    this.linesForTable = dimensionValues;
                    this.loading = false;

                   // console.log(this.dimensionValueId, this.dimensionId, this.linesForTable);

                    if (this.linesForTable && this.linesForTable.length && this.dimensionValueId)
                    {
                        var findTreeNode = null;

                        for (var node of this.linesForTable)
                        {
                            findTreeNode = this.findTreeNodeRecursively(node, this.dimensionValueId);

                            if (findTreeNode != null)
                            {
                                break;
                            }
                        }

                        //console.log(findTreeNode);

                        if (findTreeNode)
                        {
                            this.selected = this.selectedDimensionValue = findTreeNode;
                        }
                    }
                });
        }
    }

    findTreeNodeRecursively(node: TreeNode, idToFind: number)
    {
        if (node.data.id == idToFind)
        {
            return node;
        }

        if (node.children != null) {
            for (var childNode of node.children) {
                var foundNode = this.findTreeNodeRecursively(childNode, idToFind);

                if (foundNode)
                {
                    return foundNode;
                }
            }
        }
    }

    changeAllocationItemId(newValue) {
        this.dimensionValueId = newValue;
        this.dimensionValueIdChange.emit(newValue);
    }

    okClick() {
        this.selectedDimensionValue = this.selected;
        this.changeAllocationItemId(this.selectedDimensionValue.data.id);
        this.displayTable = false;
        this.closed();
    }

    closed() {
        this.onClose.emit(true);
    }
}
